import React, { useEffect, useRef, useState } from "react";
import "./Edit_Profile.css";
import CircularProgress from "@mui/joy/CircularProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import Light_Black_Btn from "../../common/common_btn/light_black_btn/Light_Black_Btn";
import Success_Modal from "../../common/common_modal/success_modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import Common_Back_Header from "../../common/common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import { myAccount, myaccountUpdate } from "../../../features/my_account/Slice";
import { formatDate } from "../../../utils/common";
import {
  AllArea,
  AllCity,
  AllCountry,
  AllPincode,
  AllState,
} from "../../../features/admin/common/Slice";
import Select from "react-select";
import { IDS } from "../../../utils/IDS";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";


const Edit_Profile = () => {
  const {
    control,
    reset,
    watch,
    setError,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [sameAsPrimary, setSameAsPrimary] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.myaccount.addMyaccount);

  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);
  const cities = useSelector((state) => state.common.all_city);
  const pincodes = useSelector((state) => state.common.all_pincode);
  const areas = useSelector((state) => state.common.all_area);

  const handleCityChange = (selectedOption) => {
    console.log(selectedOption, "handleCityChange");
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    console.log(selectedOption, "handlePincodeChange");
    setValue("pincode_id", selectedOption?.value);
    setValue("area_id", null);

    dispatch(AllArea({ pincodeId: selectedOption.value }));
  };

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);

  useEffect(() => {
    getUser();
  }, [dispatch]);

  const getUser = async () => {
    const res = await dispatch(myAccount());
    const data = res?.payload?.data;

    if (data) {
      reset({
        ...data,
        date_of_birth: data?.date_of_birth
          ? formatDate(data?.date_of_birth, false, true)
          : null,
      });
    }
  };

  const handleSameAsPrimary = (e) => {
    const checked = e.target.checked;
    setSameAsPrimary(checked);

    if (checked) {
      setValue("alternate_no", watch("contact_no"));
    } else {
      setValue("alternate_no", "");
    }
  };

  useEffect(() => {
    if (sameAsPrimary) {
      setValue("alternate_no", watch("contact_no"));
    }
  }, [watch("contact_no")]);

  const onSubmit = async (data) => {
    console.log("FORM DATA:", data);
    const sendData = new FormData();
    sendData.append("name", data.name || "");
    sendData.append("email", data.email || "");
    sendData.append("contact_no", data.contact_no || "");
    sendData.append("alternate_no", data.alternate_no || "");
    sendData.append("date_of_birth", data.date_of_birth || "");
    sendData.append("country_id", data.country_id?.value || "");
    sendData.append("state_id", data.state_id?.value || "");
    sendData.append("city_id", data.city_id?.value || "");
    sendData.append("pincode_id", data.pincode_id?.value || "");
    sendData.append("area_id", data.area_id?.value || "");

    sendData.append("building", data.building || "");
    sendData.append("apartment", data.apartment || "");
    sendData.append("street", data.street || "");
    sendData.append("floor", data.floor || "");
    sendData.append("direction", data.direction || "");
    sendData.append("address_id", data.address_id || "");

    if (data.image) sendData.append("image", data.image);

    const res = await dispatch(myaccountUpdate(sendData));

    // console.log({ myaccountUpdate: res });

    // setShowSuccessModal(true);
    // setTimeout(() => setShowSuccessModal(false), 3000);

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        navigate("/profile");
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload?.errors?.contact_no,
        });
      }
    }
  };

  const selectedImage = watch("image");
  const fileInputRef = useRef(null);

  return (
    <section className="Edit_Profile">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />
        <div className="profile_form">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="profile_pic_container">
                <div className="bg_img_div">
                  <img
                    src={"/assets/images/profile/profile_form/profile_bg.png"}
                    className="bg_img"
                  />
                </div>

                <div className="profile_img_div">
                  <img
                    src={
                      selectedImage instanceof File
                        ? URL.createObjectURL(selectedImage)
                        : user?.image
                          ? IDS.IMG_URL + user.image
                          : "/assets/images/profile/profile_form/profile_bg.png"
                    }
                    className="profile_img"
                  />
                </div>

                <div className="progeress_holder">
                  <CircularProgress
                    size="lg"
                    sx={{
                      "--CircularProgress-size": "90px",
                      "--CircularProgress-thickness": "6px",
                    }}
                    determinate
                    value={user?.pfp_percentage}
                  >
                    <div className="percentage_holder">
                      {/* <span className="percantage">
                        <FontAwesomeIcon
                          className="percantage"
                          icon={faCamera}
                        />
                      </span> */}
                      <span
                        className="percantage"
                        onClick={() => fileInputRef.current?.click()}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          className="percantage"
                          icon={faCamera}
                        />
                      </span>

                      <Controller
                        name="image"
                        control={control}
                        render={({ field }) => (
                          <input
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) field.onChange(file);
                              setValue("image", file, { shouldValidate: true });
                            }}
                          />
                        )}
                      />
                    </div>
                  </CircularProgress>
                </div>
              </div>

              <div className="main_form_div">
                <div className="row">
                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Full Name"
                        {...register("name", {
                          required: "Full Name is required",
                          minLength: {
                            value: 3,
                            message: "Name must be at least 3 characters",
                          },
                          maxLength: {
                            value: 50,
                            message: "Name cannot exceed 50 characters",
                          },
                          pattern: {
                            value: /^[A-Za-z\s]+$/,
                            message: "Name can contain only letters and spaces",
                          },
                          validate: (value) =>
                            value.trim().length > 0 || "Name cannot be empty spaces",
                        })}
                      />

                    </Form.Group>
                    {errors.name && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.name.message}
                      </p>
                    )}
                  </div>

                  <div className="col-sm-6">
                    {/* <Form.Group className="gray_input_group">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Last Name"
                      />
                    </Form.Group> */}
                    <Form.Group className="gray_input_group">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                            message: "Enter a valid email address",
                          },
                        })}
                        placeholder="Enter Email"
                      />
                    </Form.Group>
                    {errors.email && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.email.message}
                      </p>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Phone Number</Form.Label>

                      <Form.Control
                        placeholder="Contact Number"
                        type="text"
                        name="contact_no"
                        maxLength={10} // restrict typing to 10 digits
                        {...register("contact_no", {
                          required: "Contact Number is required",
                          pattern: {
                            value: /^[0-9]+$/, // only numbers
                            message: "Only digits are allowed",
                          },
                          minLength: {
                            value: 10,
                            message: "Contact Number must be exactly 10 digits",
                          },
                          maxLength: {
                            value: 10,
                            message: "Contact Number must be exactly 10 digits",
                          },
                        })}
                      />
                    </Form.Group>
                    {errors.contact_no && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.contact_no.message}
                      </p>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Concern Phone Number</Form.Label>

                      <Form.Control
                        placeholder="Concern Phone Number"
                        type="text"
                        name="alternate_no"
                        maxLength={10} // restrict typing to 10 digits
                        {...register("alternate_no", {
                          required: "Concern Phone Number is required",
                          pattern: {
                            value: /^[0-9]+$/, // only numbers
                            message: "Only digits are allowed",
                          },
                          minLength: {
                            value: 10,
                            message:
                              "Concern Phone Number must be exactly 10 digits",
                          },
                          maxLength: {
                            value: 10,
                            message:
                              "Concern Phone Number must be exactly 10 digits",
                          },
                        })}
                      />

                      <Form.Check
                        type="checkbox"
                        label="Same as First Contact"
                        className="mt-2"
                        checked={sameAsPrimary}
                        onChange={handleSameAsPrimary}
                      />
                    </Form.Group>
                    {errors.alternate_no && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.alternate_no.message}
                      </p>
                    )}
                  </div>

                  {/* <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="name"
                        placeholder="Enter Email"
                      />
                    </Form.Group>
                  </div> */}

                  {/* <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Date of Birth*</Form.Label>
                      <Form.Control
                        type="date"
                        {...register("date_of_birth", {
                          required: "Date of Birth is required",
                        })}
                        max={today}
                        placeholder="Enter Date of Birth"
                      />
                    </Form.Group>
                    {errors.date_of_birth && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.date_of_birth.message}
                      </p>
                    )}
                  </div> */}

                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Date of Birth*</Form.Label>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Controller
                          name="date_of_birth"
                          control={control}
                          rules={{
                            required: "Date Of_Birth is required",
                          }}
                          render={({ field }) => (
                            <DatePicker
                              label="Select Date of Birth"
                              maxDate={dayjs().subtract(1, "day")}
                              value={field.value ? dayjs(field.value) : null}
                              onChange={(newValue) => {
                                const formattedDate = newValue
                                  ? newValue.format("YYYY-MM-DD")
                                  : null;
                                field.onChange(formattedDate);
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  error: !!errors?.dob,
                                  helperText: errors?.dob?.message,
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </div>

                  {/* <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as={"textarea"}
                        type="text"
                        readOnly={true}
                        name="address"
                        {...register("address", {

                        })}
                        placeholder="Enter Address"
                      />
                    </Form.Group>
                    {errors.address && (
                      <p style={{ fontSize: "13px", color: "red" }}>
                        {errors.address.message}
                      </p>
                    )}
                  </div> */}

                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>House name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="building"
                        placeholder={"House name*"}
                        {...register("building", {
                          required: "House name required",
                        })}
                      />
                    </Form.Group>
                    {errors?.building && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.building?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>House No*</Form.Label>
                      <Form.Control
                        type="text"
                        name="apartment"
                        placeholder={"House no.*"}
                        {...register("apartment", {})}
                      />
                    </Form.Group>
                    {errors?.apartment && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.apartment?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Floor*</Form.Label>
                      <Form.Control
                        type="text"
                        name="floor"
                        placeholder="Floor*"
                        {...register("floor", {
                          // required: "Floor required",
                        })}
                      />
                    </Form.Group>
                    {errors?.floor && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.floor?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Street*</Form.Label>
                      <Form.Control
                        type="text"
                        name="street"
                        placeholder="Street*"
                        {...register("street", {
                          required: "Street name required",
                        })}
                      />
                    </Form.Group>
                    {errors?.street && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.street?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Additional directions</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        type="text"
                        name="direction"
                        placeholder="Additional directions (optional)"
                        {...register("direction", {
                          // required: "Additional directions are required",
                        })}
                      />
                    </Form.Group>
                    {errors?.direction && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.direction?.message}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Select Country of Residence</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="country_id"
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            placeholder="Select Country"
                            options={countries}
                            className="mb-3"
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: errors.country_id ? "red" : base,
                              }),
                            }}
                            {...field}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption);
                              setValue("state_id", null);
                              setValue("city_id", null);
                              setValue("pincode_id", null);
                              dispatch(
                                AllState({ countryId: selectedOption.value }),
                              );
                            }}
                          />
                        )}
                      />
                      {errors.country_id && (
                        <p style={{ fontSize: "13px", color: "red" }}>
                          {errors.country_id.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  {/* STATE */}
                 <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Select State</Form.Label>

                      <Controller
                        className="Select_Dropdown_holder"
                        name="state_id"
                        control={control}
                        rules={{ required: "State is required" }}
                        render={({ field }) => (
                          <Select
                            placeholder="Select State"
                            options={states}
                            className="mb-3"
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: errors.state_id ? "red" : base,
                              }),
                            }}
                            {...field}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption);
                              setValue("city_id", null);
                              setValue("pincode_id", null);
                              dispatch(
                                AllCity({ stateId: selectedOption.value }),
                              );
                            }}
                          />
                        )}
                      />
                      {errors.state_id && (
                        <p style={{ fontSize: "13px", color: "red" }}>
                          {errors.state_id.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Select City</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="city_id" // Form field name
                        control={control}
                        rules={{ required: "City is required" }}
                        render={({ field }) => (
                          <Select
                            noOptionsMessage={() => "City in this State"}
                            className="mb-3"
                            placeholder="Select City"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.city_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={cities}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption); // Update Controller's value
                              handleCityChange(selectedOption);
                              setValue("city_id", selectedOption);
                            }}
                          />
                        )}
                      />
                      {errors?.city_id && (
                        <div style={{ fontSize: "13px", color: "red" }}>
                          {errors?.city_id?.message}
                        </div>
                      )}
                    </Form.Group>
                  </div>

         <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Select Pincode</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="pincode_id" // Form field name
                        control={control}
                        rules={{ required: "Pincode is required" }}
                        render={({ field }) => (
                          <Select
                            noOptionsMessage={() => "Pincode not available"}
                            className="mb-3"
                            placeholder="Select Pincode"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.pincode_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={pincodes}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption); // Update Controller's value
                              handlePincodeChange(selectedOption);
                              setValue("pincode_id", selectedOption);
                            }}
                          />
                        )}
                      />
                      {errors?.pincode_id && (
                        <div style={{ fontSize: "13px", color: "red" }}>
                          {errors?.pincode_id?.message}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                 <div className="col-sm-6">
                    <Form.Group className="gray_input_group">
                      <Form.Label>Select Area</Form.Label>
                      <Controller
                        className="Select_Dropdown_holder"
                        name="area_id" // Form field name
                        control={control}
                        rules={{ required: "Area is required" }}
                        render={({ field }) => (
                          <Select
                            noOptionsMessage={() =>
                              "no Area Available in this Pincode"
                            }
                            className="mb-3"
                            placeholder="Select Area"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.area_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={areas}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption); // Update Controller's value
                              // handlePincodeChange(selectedOption);
                              // setValue("area_id", selectedOption);
                            }}
                          />
                        )}
                      />
                      {errors?.area_id && (
                        <div style={{ fontSize: "13px", color: "red" }}>
                          {errors?.area_id?.message}
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="btn_holder">
                    {/* <Pink_Btn
                      btnText={"Update"}
                      onClick={() => {
                        setShowSucsessModal(true);
                        setTimeout(() => {
                          setShowSucsessModal(false);
                        }, 3000);
                      }}
                    /> */}
                    <Pink_Btn
                      btnText="Update"
                      onClick={handleSubmit(onSubmit)}
                    />
                    <Light_Black_Btn
                      btnText={"Cancel"}
                      onClick={() => {
                        navigate(-1);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Profile Updated Successfully!"
      />
    </section>
  );
};

export default Edit_Profile;
